import React from "react";
import {MenuItem} from "@mui/material";
import CustomTextField from "../../customMUIComponents/CustomTextField";
import Typography from "@mui/material/Typography";

interface BankDataProps {
    isSelling: boolean | undefined,
    setIsSelling: (isSelling: boolean) => void,
}

const BankData = ({isSelling, setIsSelling}: BankDataProps) => {

    return (
        <>
            <CustomTextField
                variant={"outlined"}
                value={isSelling === undefined ? "" : isSelling ? "yes" : "no"}
                label={"Souhaitez-vous vendre des produits en ligne ?"}
                setField={(fieldValue) => setIsSelling(fieldValue === "yes")}
                select
                selectOptions={[
                    <MenuItem key="yes" value={'yes'}>Oui</MenuItem>,
                    <MenuItem key="no" value={'no'}>Non</MenuItem>
                ]}
                mb={4}
                textAlign={"left"}
                required
            />
            {isSelling && (
                <>

                    <Typography
                        textAlign={"left"}
                        variant={"firstVariant"}
                        mb={4}
                    >
                        Une fois votre compte validé, vous serez amené à créer un compte Stripe Express pour recevoir vos paiements.
                        Cela se fera simplement et rapidement depuis votre compte Looty. Nous ne stockons pas vos informations bancaires.
                        Notre partenaire Stripe est le leader mondial des paiements en ligne et est conforme aux normes de sécurité les plus strictes.
                    </Typography>
                </>
            )}
        </>
    );
}

export default BankData
